import React, { Component } from 'react'
import starIcon from '../../icons/star.svg';
import starIconFilled from '../../icons/star_filled.svg';
import { iconSwitch } from './IconSwitch'
import { connect } from 'react-redux'
import { contentFunctions } from './RestaurantSummaryFunctions'
import { Redirect, Link } from 'react-router-dom'
import messageIcon from '../../icons/messagePending2.svg'

class RestaurantCompare extends Component { 
  constructor (props){
    super(props);
    this.state = {
    lastClicked: '',
    allContentToClicked: '',
    httpResponse:'',
    mapUrl:'',
    blurb:'',
    iconImage:'',
    iconSize: 60,
    iconPadding: '20%',
    spanOption:'grid-test'
    }
  }
  
  onFavorite = this.props.onFavorite;

  componentDidMount(){
    if(this.state.lastClicked === "" && this.props.project.content !== ""){
      this.setState({lastClicked:this.props.project.content})
    }
    if(this.state.iconImage === ''){
      iconSwitch(this.props.project.primaryTag, this);
      }
  }

  componentDidUpdate(props){
    if(this.state.lastClicked === "" && this.props.project.content !== ""){
      this.setState({lastClicked:this.props.project.content})
    }
    

    if(this.state.mapUrl === ''){
      this.getMap()
    }

    var blurb = '';
    
    if(this.props.project && this.props.distance && this.props.isOpen !== undefined){
      const openIsit = this.props.isOpen?"open":"closed";
      var reviewCount = "unknown";
      if(this.props.project.reviewCount){
        reviewCount = this.props.project.reviewCount
        }
      const reviewStars = 'unknown';
      const favoriteCount = 'unknown';
      blurb = this.props.project.name + " is a " + this.props.project.primaryTag + ' restaurant that is currently '+
       openIsit + '. Located ' + this.props.distance.toString() + ' miles from you. It has ' + reviewCount + ' reviews averaging '
       + reviewStars + ' stars.  It is a favorite of ' + favoriteCount + ' users.'   
      
      if(this.state.iconImage === ''){
        iconSwitch(this.props.project.primaryTag, this);
      }

      if(blurb !== '' && this.state.blurb !== blurb){
        this.setState({blurb:blurb})
        }

      if(this.state.lastClicked === this.props.project.content && this.state.blurb !== ''){
        this.setState({lastClicked:this.state.blurb})
      }

      if(this.state.lastClicked === this.props.project.address && this.state.spanOption !== 'grid-test2'){
        this.setState({spanOption:'grid-test2'})
      }
      else if(this.state.lastClicked !== this.props.project.address &&this.state.spanOption !== 'grid-test'){
        this.setState({spanOption:'grid-test'})
      }

    }

  }

  onMessage(message, id){
    console.log(message, id);
    this.setState({message:message, id:id, redirect:true})
  }

  getMap(){  
    const centerPoint = this.props.project.location;
    const mapUrl = "https://dev.virtualearth.net/REST/v1/Imagery/Map/Road/"+centerPoint+"/15?mapSize=360,350&pp="+centerPoint+"&format=PNG&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O"
    if(this.state.mapUrl !== mapUrl){
      this.setState({mapUrl:mapUrl});
      }   
    //https://dev.virtualearth.net/REST/v1/Imagery/Map/Road/Routes?wp.0=Seattle,WA;64;1&wp.1=Redmond,WA;66;2&key={BingMapsAPIKey}   
  }

  render() { 
  if(this.state.redirect){
    return <Redirect to={'/message/' + this.state.id + '/' + this.state.message + '/null'} />
  }
  const { project, favorite, original, userId, message } = this.props;
  const favIcon = favorite?starIconFilled:starIcon;
  const online_or_menu = project.orderUrl!==""?project.orderUrl:project.menuUrl;
  const online_menu = project.orderUrl!==""?'Order Online':'Menu';

  //this should all be in componentDidUpdate
  if(project && original && document.getElementById(project.id+"name") 
    && document.getElementById(project.id+"hours") && document.getElementById(project.id+"tags")
    && document.getElementById(project.id+"address") && document.getElementById(project.id+"website")
    && document.getElementById(project.id+"phoneNumber") && document.getElementById(project.id+"menu")
    ){
    if(project.name!==original.name){
      document.getElementById(project.id+"name").style.border = '2px solid red';
    }
    if(JSON.stringify(project.hours)!==JSON.stringify(original.hours))
    {
      document.getElementById(project.id+"hours").style.border = '2px solid red';
    }
    if(JSON.stringify(project.tags)!==JSON.stringify(original.tags))
    {
      document.getElementById(project.id+"tags").style.border = '2px solid red';
    }
    if(project.primaryTag !== original.primaryTag){
      document.getElementById(project.id+"tagIcon").style.border = '2px solid red';
    }
    if(project.address!==original.address){
      document.getElementById(project.id+"address").style.border = '2px solid red';
    }
    if(project.url!==original.url){
      document.getElementById(project.id+"website").style.border = '2px solid red';
    }
    if(project.orderUrl!==original.orderUrl){
      document.getElementById(project.id+"menu").style.border = '2px solid red';
    }
    if(project.menuUrl!==original.menuUrl){
      document.getElementById(project.id+"menu").style.border = '2px solid red';
    }
    if(project.phoneNumber!==original.phoneNumber){
      document.getElementById(project.id+"phoneNumber").style.border = '2px solid red';
    }
    if(project.menu!==original.menu){
      document.getElementById(project.id+"menu").style.border = '2px solid red';
    }
  }
  
  
  return (
    <div className={this.state.spanOption}>
      <div className='tagIcon' id={project.id+'tagIcon'}><img alt="Tag Icon" style={{"paddingRight":this.state.iconPadding}} height={this.state.iconSize} src={this.state.iconImage}/></div>
      {
        message && <div className='messageIcon'><img src={messageIcon} onClick={() => this.onMessage(message, userId)} className="favIcon" alt="message" width="40px" height="40px" viewBox="0 0 40 40"/></div>  
      }
  <div className='image-stack'>
    <div className="new-wrapper">
        <div className="new-nav-text2">
            <div id={project.id+"name"}><a onClick={ () => this.setState({lastClicked: this.state.blurb}) }>{project.name}</a></div>
        </div>

        <div className="new-nav-text">
            <div><a onClick={ () => this.setState({lastClicked: 'Reviews coming soon!'}) }>Reviews</a></div>
            <div id={project.id+"hours"}><a onClick={ () => this.setState({lastClicked: project.hours}) }>Hours</a></div>
            <div id={project.id+"address"}><a onClick={ () => this.setState({lastClicked: project.address}) }>Address</a></div>
            <Link to={'/edit/' + project.restaurantId} key={project.restaurantId}>Edit</Link>
            <div><img src={favIcon} onClick={() => this.onFavorite(project)} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            
        </div>
                      
        <div className="new-main" style={{overflowY:"auto"}}>
          <div>{ contentFunctions.displayContent(this.state.lastClicked, project, ()=>{}) }</div>

          <p> { this.state.lastClicked===project.address && this.state.mapUrl!=='' && <img alt='Map' className="mapImage" src = {this.state.mapUrl}/> } </p>
          <p> { this.state.lastClicked==='Reviews coming soon!' && <Link to={'/reviews/' + project.restaurantId} key={'review'+project.restaurantId}>Review</Link>  } </p>
        </div>
      
        <div className="new-bottom">
          <div id={project.id+"website"}><a onClick = {() => newWindow(project.url)}>Website</a></div>
          <div id={project.id+"menu"}><a onClick = {() => newWindow(online_or_menu)}>{online_menu}</a></div>
          <div id={project.id+"phoneNumber"}><a>{project.phoneNumber}</a></div>
          <div id={project.id+"tags"}><a onClick={ () => this.setState({lastClicked: project.tags}) }>Tags</a></div>
        </div>

    </div>
  </div>
  </div>
  )
}
}

function newWindow(url) {
    var newWind = window.open('http://' + url, '_blank');
    newWind.opener = null;
  }

const mapStateToProps = (state) => {
  return {
    state
  }
}

export default connect(mapStateToProps)(RestaurantCompare)